import { render, staticRenderFns } from "./NavTabs.vue?vue&type=template&id=6a3d8b20&scoped=true"
import script from "./NavTabs.vue?vue&type=script&lang=js"
export * from "./NavTabs.vue?vue&type=script&lang=js"
import style0 from "./NavTabs.vue?vue&type=style&index=0&id=6a3d8b20&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3d8b20",
  null
  
)

export default component.exports